import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { buildMarketDataKeys } from '../../../../../../../stores/websocketStore/utils/marketDataRouting';
import {
  mapAccountsFromBalances,
  resolveMarketDataBrokerage,
} from '../../../../../../../utils/accountRouting';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3, Body4 } from '../../../../../../atomic/text/Text';
import style from './TimeAndSalesTable.module.css';

export const TimeAndSalesTable = observer(({ tradePlanId }) => {
  const { priceDataStore, tradePlanStore, accountBalanceStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  if (tradePlan === null) return null;

  const accounts = mapAccountsFromBalances(accountBalanceStore?.balances);
  const brokerage = resolveMarketDataBrokerage({
    accountNumber: tradePlan.accountNumber,
    accounts,
    currentBrokerage: tradePlan.brokerage,
    dataSource: tradePlan.dataSource,
    symbol: tradePlan.symbol,
  });
  const hash = buildMarketDataKeys({
    symbol: tradePlan.symbol,
    dataSource: tradePlan.dataSource,
    brokerage,
  }).find((key) => priceDataStore.timeSales[key]);
  const data = priceDataStore.timeSales[hash] ?? null;

  if (data === null) return null;
  return (
    <div className={style.container}>
      <table className={style.table}>
        <thead>
          <tr>
            <th>
              <Body3 color={colors.lightGrey} fontWeight={700}>
                Last
              </Body3>
            </th>
            <th>
              <Body3 color={colors.lightGrey} fontWeight={700}>
                Bid
              </Body3>
            </th>
            <th>
              <Body3 color={colors.lightGrey} fontWeight={700}>
                Ask
              </Body3>
            </th>
            <th>
              <Body3 color={colors.lightGrey} fontWeight={700}>
                Vol
              </Body3>
            </th>
          </tr>
        </thead>
        <tbody className={style.tbody}>
          {data.collection.map(({ bid, ask, last, volume, id }) => {
            let color = colors.black;
            if (Number(last) > Number(ask)) color = colors.orange;
            if (Number(last) < Number(bid)) color = colors.purple;
            if (Number(last) === Number(ask)) color = colors.green;
            if (Number(last) === Number(bid)) color = colors.red;

            return (
              <tr
                key={id}
                style={{
                  backgroundColor: color,
                  borderTop: color === colors.black ? '1px solid grey' : 'none',
                }}
              >
                <td>
                  <Body4
                    fontWeight={volume > 1000 ? 700 : 500}
                    color={colors.lightGrey}
                  >
                    {ApplyRounding(last, 2)}
                  </Body4>
                </td>
                <td>
                  <Body4
                    fontWeight={volume > 1000 ? 700 : 500}
                    color={colors.lightGrey}
                  >
                    {ApplyRounding(bid, 2)}
                  </Body4>
                </td>
                <td>
                  <Body4
                    fontWeight={volume > 1000 ? 700 : 500}
                    color={colors.lightGrey}
                  >
                    {ApplyRounding(ask, 2)}
                  </Body4>
                </td>
                <td>
                  <Body4
                    fontWeight={volume > 1000 ? 700 : 500}
                    color={colors.lightGrey}
                  >
                    {volume}
                  </Body4>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

// const bidAskScale = scaleLinear()
//   .domain([row.bid, row.ask])
//   .range([0, 100]);
// const average = priceDataStore.timeSales[hash].average;
// const sum = priceDataStore.timeSales[hash].sum;
// const squareSum = priceDataStore.timeSales[hash].squareSum;
// const variance =
//   (data.collection.length * squareSum - Math.pow(sum, 2)) /
//   Math.pow(data.collection.length, 2);
// const stdDeviation = Math.sqrt(variance);
// const remainder = row.volume - average;
// const numberOfStandardDeviations =
//   remainder > 0
//     ? Math.ceil(remainder / stdDeviation)
//     : Math.floor(remainder / stdDeviation);
// const volumeMap = scaleLinear().domain([-3, 3]).range([20, 100]);
// const hue = bidAskScale(row.last) < 50 ? 0 : 112;
// const saturation = bidAskScale(row.last);
// const lightness = volumeMap(numberOfStandardDeviations);
// const color = `hsl(${hue},${saturation}%, ${lightness}%)`;
